import { Eye, Shield } from 'lucide-react';
import type { ReactNode } from 'react';
import { colors } from '../../lib/theme';

function Badge({ label, icon }: { label: string; icon?: ReactNode }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-1.5 text-[13px] font-medium"
      style={{
        border: `1px solid ${colors.border}`,
        backgroundColor: colors.bgSecondary,
        color: colors.textSecondary,
      }}
    >
      {icon}
      {label}
    </span>
  );
}

export function Hero() {
  return (
    <section className="pt-16 pb-2 max-w-3xl">
      <div
        className="mb-7 inline-flex items-center gap-2 rounded-full px-3 py-1.5"
        style={{
          border: `1px solid ${colors.border}`,
          backgroundColor: colors.bgSecondary,
        }}
      >
        <span
          className="h-1.5 w-1.5 rounded-full"
          style={{ backgroundColor: colors.green, boxShadow: `0 0 0 3px ${colors.green}33` }}
        />
        <span className="text-[12.5px] font-medium" style={{ color: colors.textSecondary }}>
          Transparent sources — not a black-box ESG score
        </span>
      </div>
      <h1 className="display text-4xl sm:text-5xl lg:text-[56px] leading-[1.1] tracking-tight">
        You already know how you feel.{' '}
        <span style={{ color: colors.textMuted, fontWeight: 500 }}>
          Now look at what you own.
        </span>
      </h1>
      <p className="mt-7 text-lg leading-relaxed max-w-xl" style={{ color: colors.textSecondary }}>
        Paste your tickers and see your holdings checked against the lenses you choose —{' '}
        <span className="font-semibold" style={{ color: colors.textPrimary }}>
          occupation &amp; settlements
        </span>
        ,{' '}
        <span className="font-semibold" style={{ color: colors.textPrimary }}>
          defense contractors
        </span>
        , and{' '}
        <span className="font-semibold" style={{ color: colors.textPrimary }}>
          Shariah compliance
        </span>
        . Every verdict links to the source. You decide what to do next.
      </p>
      <div className="mt-6 flex flex-wrap gap-2">
        <Badge label="Free" />
        <Badge label="No signup" />
        <Badge icon={<Shield className="h-3.5 w-3.5" style={{ color: colors.textMuted }} />} label="Transparent sources" />
        <Badge icon={<Eye className="h-3.5 w-3.5" style={{ color: colors.textMuted }} />} label="No tracking" />
      </div>
    </section>
  );
}
